export default __webpack_public_path__ + "static/Machine-learning-d585f19f3dd538613eae0a46542f2479.webp";